import { UserDtoSchema } from "@/modules/profile/userProfile/userDto"
import { BlockSessionInputDtoSchema, SessionBlockDtoSchema } from "@/modules/sessions/gateway/sessionBlockDto"
import { SocialPostResumeLightDtoSchema } from "@/modules/social/gateway/socialDto"
import { MAX_64_CHARACTERS, MAX_65535_CHARACTERS } from "@/typings/formik"
import z from "zod/v4"

export const BoxSessionDetailsDtoSchema = z
  .object({
    sessionId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    owner: UserDtoSchema.nullable(),
    programId: z.string(),
    hideSessionContent: z.boolean().nullable(),
    weightliftingTag: z.boolean(),
    gymnasticTag: z.boolean(),
    cardioTag: z.boolean(),
    date: z.iso.date().nullable(), // Format : "2026-03-26"
    restDay: z.boolean().nullable(),
    virtualProgramByDateIndex: z.number().nullable(),
    blocks: z.array(z.lazy(() => SessionBlockDtoSchema)),
    sessionCompletedByUser: z.boolean(),
    socialPostId: z.string().nullable(),
    socialResume: SocialPostResumeLightDtoSchema.nullable(),
  })
  .meta({ id: "BoxSessionDetailsDtoSchema" })

export type BoxSessionDetailsDto = z.infer<typeof BoxSessionDetailsDtoSchema>

export const BoxSessionCreateInputDtoSchema = z
  .object({
    programId: z.string(),
    name: z.string().max(MAX_64_CHARACTERS),
    description: z.string().max(MAX_65535_CHARACTERS),
    blocks: z.array(z.lazy(() => BlockSessionInputDtoSchema)),
    hideSessionContent: z.boolean().nullable(),
    weightliftingTag: z.boolean(),
    gymnasticTag: z.boolean(),
    cardioTag: z.boolean(),
  })
  .meta({ id: "BoxSessionCreateInputDtoSchema" })

export type BoxSessionCreateInputDto = z.infer<typeof BoxSessionCreateInputDtoSchema>

export const BoxSessionUpdateInputDtoSchema = z
  .object({
    name: z.string().max(MAX_64_CHARACTERS),
    description: z.string().max(MAX_65535_CHARACTERS).nullable(),
    blocks: z.array(z.lazy(() => BlockSessionInputDtoSchema)),
    hideSessionContent: z.boolean().nullable(),
    weightliftingTag: z.boolean(),
    gymnasticTag: z.boolean(),
    cardioTag: z.boolean(),
  })
  .meta({ id: "BoxSessionUpdateInputDtoSchema" })

export type BoxSessionUpdateInputDto = z.infer<typeof BoxSessionUpdateInputDtoSchema>
